import { EventCalendarValues } from '../components/CalendarEvent';
import { CreateClassEventReq } from '../services/api.types';

export type Weekdays = EventCalendarValues['weekdays'];

export const daysArr: (keyof Weekdays)[] = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export type RecurrenceValues = Pick<
  CreateClassEventReq,
  'startHour' | 'duration' | 'startDate' | 'timezone' | 'recurrenceRule'
>;

export type RecurrenceDefaultValues = Pick<
  EventCalendarValues,
  | 'startDate'
  | 'startHour'
  | 'endHour'
  | 'weekdays'
  | 'bypassConflict'
  | 'intervalType'
  | 'intervalNumber'
  | 'recurrenceType'
  | 'count'
  | 'until'
  | 'updateClassParams'
>;
